import axios from 'axios';
import { useEffect, useState } from 'react';
import helmet from '../assets/helmet.png';
import { url } from '../utils/config';
import BookingForm from './BookingForm';
import { toast } from 'react-toastify';
import { useRecoilState } from 'recoil';
import loaderStateAtom from '../atoms/loaderStateAtom';
import backButton from "../assets/backButton.png";
import { useNavigate } from 'react-router-dom';
import nextIcon from '../assets/icons/next_icon.png'
import { containerOne } from '../utils/style';
import navHeaderAtom from '../atoms/navHeaderAtom';

function SpecialEquipments() {
    const [ specialEquipments, setSpecialEquipments ] = useState({specialEquipments: [], items: []});
    const [ showBookingForm, setShowBookingForm ] = useState(false);
    const [ equipmentIndex, setEquipmentIndex ] = useState();
    const [ showLoader, setShowLoader ] = useRecoilState(loaderStateAtom);
    const [ header, setHeader ] = useRecoilState(navHeaderAtom)
    const navigate = useNavigate();

    useEffect(() => {
        setHeader('Special Equipment')
        getSpecialEquipments()
    }, [])

    function toggleBookingForm(index) {
        setEquipmentIndex(index);
        setShowBookingForm(true);
    }
    
    async function getSpecialEquipments() {
        try {
            setShowLoader(true)
            const reqUrl = url + '/special_equipments';
            const token = window.localStorage.getItem('token');
            const headers = { authorization: `bearer ${token}` };
            const {data} = await axios.get(reqUrl, { headers });
            setSpecialEquipments(data.data)
            console.log(data)
            setShowLoader(false)
        } catch (error) {
            setShowLoader(false)
            toast.error(error.response.data.message, { autoClose: 3000 })
        }
    }


    
    return(
        <div className={containerOne}>
            <div classNAme='flex justify-center flex-auto border'>
                {
                    showBookingForm ? <BookingForm id={specialEquipments.specialEquipments[equipmentIndex]['id']} name={specialEquipments.specialEquipments[equipmentIndex]['name']} setShowModal={ setShowBookingForm } /> : null
                }
            </div>
            <div>
                {
                    specialEquipments.specialEquipments.map((se, ind) =>
                    <div key={ind} className='flex items-center justify-between px-2 border-b-2 mt-4'>
                        <div className='flex gap-4 items-center mb-4'>
                            <div>
                                <img src={url + '/' + se.imageUrl} className='h-16 w-16 max-h-16 max-w-16 min-h-16 min-w-16'/>
                            </div>
                            <div>
                                <div className=''>{se.name}</div>
                                <div className='text-xs text-gray-600'>
                                    {`Quantity - ${specialEquipments.items.filter(item => item.special_equipment_id === se.id).length}`}
                                </div>
                            </div>
                        </div>
                        <div className='flex items-center cursor-pointer'>
                            <img src={nextIcon} onClick={() => toggleBookingForm(ind)}/>
                        </div>
                    </div>
                    )
                }
            </div>
        </div>
    )
}


export default SpecialEquipments;